import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from '@zola/zola-ui';

import { fetchWeddingThemeGroup, fetchWeddingThemeV2 } from '../../../actions/WeddingActions';
/* image imports */
import computer from '../../../assets/images/pages/computer.png';

class CurrentThemeViewer extends Component {
  componentWillReceiveProps(nextProps) {
    const { getThemeGroup } = this.props;
    if (nextProps.theme.key !== this.props.theme.key) {
      getThemeGroup(nextProps.theme.key);
    }
  }

  render() {
    const { onboard, weddingTheme, themeGroupTitle } = this.props;
    const production = window.zola.env === 'production';
    const preOnboardHED = 'Choose your design';
    const preOnboardDEK = 'We’ll customize your favorite with the info you shared, then help you fill the rest out. Don’t forget… all of our designs are free!';

    return (
      <div>
        <div id="current-theme-viewer-container">
          <div>
            <div className="theme-intro-container row">
              {!onboard
              && (
              <div className="currently-selected-container">
                <div className="onboarded-theme-viewer current-theme-viewer">
                  <div className="current-theme-container col-xs-6 col-sm-6 col-md-5 col-md-offset-1 col-lg-offset-3 col-lg-3">
                    <div className="current-theme-tile">
                      <div className={production ? 'current-theme-preview' : 'current-theme-preview chrome-icon'} style={{ backgroundImage: `url(${weddingTheme.preview_images})` }} />
                    </div>
                  </div>
                  <div className="theme-detail col-xs-6 col-sm-6 col-md-5">
                    {
                      window.zola.env === 'production' && <h4 className="text-sans">Selected Design</h4>
                    }
                    {
                      window.zola.env !== 'production' && <div className="green-label-btn"><i className="zolaicon zolaicon-checkmark" />Selected Design</div>
                    }
                    <h2 className="text-sans">{themeGroupTitle}</h2>
                    <Link arrow href="/wedding/manage/website/pages" ref={(el) => { this.editButton = el; }}>Edit Your Website</Link>
                  </div>
                  <div className="col-xs-12 col-sm-6 col-md-5">
                    <div className="theme-instructions">
                      <h3 className="text-sans">Want to select a different design?</h3>
                      <p>You can easily switch to a new one and we&#x27;ll transfer all your information over. Don&#x27;t forget: all of our designs are free. Enjoy!</p>
                    </div>
                  </div>
                </div>
              </div>
              )
              }
              {onboard
              && (
              <div className="currently-selected-container-onboard">
                <div className="theme-onboard-v2 clearfix">
                  <div className="col-xs-12 col-sm-9">
                    <h3>{preOnboardHED}</h3>
                    <p>{preOnboardDEK}</p>
                  </div>
                  <div className="col-sm-3 hidden-xs">
                    <img src={computer} alt="Start your Wedding Website" className="img-responsive center-block computer" />
                  </div>
                </div>
              </div>
              )
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CurrentThemeViewer.propTypes = {
  theme: PropTypes.shape({
    key: PropTypes.string
  }),
  themeGroupTitle: PropTypes.string,
  weddingTheme: PropTypes.shape({}),
  onboard: PropTypes.bool,
  getThemeGroup: PropTypes.func.isRequired,
};

const mapStateToProps = state => (
  {
    themeGroupTitle: state.wedding.themeGroupTitle,
    weddingTheme: state.wedding.theme,
    onboard: !state.wedding.account.disable_website_onboarding,
  }
);

const mapDispatchToProps = dispatch => (
  {
    getThemeGroup: key => dispatch(fetchWeddingThemeGroup(key)),
    getWeddingTheme: () => dispatch(fetchWeddingThemeV2()),
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CurrentThemeViewer);



// WEBPACK FOOTER //
// ./src/components/manage/website/CurrentThemeViewer.jsx